// The one rule every admin-only control asks: may I draw this? Pure and
// import-free, so the Worker's suite — the only one `npm run check` gates on —
// can load it. `useIsAdmin.ts` re-exports it.
//
// Three states go in and two come out, on purpose. `undefined` is "the
// `app_admins` read has not answered yet" (a cold load, an offline start) and
// it must draw the same as `false`: the other reading — show until told
// otherwise — flashes Venue admin at every user on every cold load, which is
// the cold-load trap in CLAUDE.md. A control that is `true`-on-`undefined` is
// the regression `test/is-admin.test.ts` exists to catch.
//
// The gate is cosmetic. Postgres refuses the write (U0.2, `is_admin()`); this
// stops the app offering what the database will refuse.

export type AdminGate = 'show' | 'hide'

export const adminGate = (isAdmin: boolean | undefined): AdminGate =>
  isAdmin === true ? 'show' : 'hide'
